import React from 'react';
import ConsultaAlertas from './ConsultaAlertas';

/**
 * Pantalla "Alertas · Operacion de seguridad" (PNT-0000-0000-0034): la misma
 * Consulta de alertas leida en contexto de seguridad. Ver ConsultaAlertas.
 */
const AlertasSeguridad = () => <ConsultaAlertas seguridad />;

export default AlertasSeguridad;
